import { endOfMonth, subMonths } from 'date-fns';
import { TFunction } from 'i18next';

import { EmployeeSpotlight as EmployeeSpotlightSchema } from '../../../schemas/spotlight';

export const createDemoSpotlight = (t: TFunction<'spotlight'>) => {
	const demoSpotlightEndTime = endOfMonth(subMonths(new Date(), 1)).toISOString();

	return EmployeeSpotlightSchema.parse({
		id: 'demo',
		userId: 'demo-user',
		companyId: 'demo-company',
		generatedByUserId: 'not-current-user',
		visibility: 'company',
		bonusIds: [],
		user: {
			id: 'demo-user',
			displayName: t('viewer.demoData.user.displayName'),
			displayFirstName: t('viewer.demoData.user.displayFirstName'),
			username: 'daniel.harris',
			profilePicUrl: null,
		},
		startTime: '2024-02-01T00:00:00.000Z',
		endTime: demoSpotlightEndTime,
		status: 'completed',
		totalReceivedCount: 19,
		totalGivenCount: 1,
		monthsAtCompany: 24,
		generationStartedAt: '2026-01-03T10:15:00.000Z',
		generationCompletedAt: '2026-01-03T10:15:14.000Z',
		generationError: null,
		sections: [
			{
				id: 'demo-section-achievements',
				type: 'achievements',
				intro: t('viewer.demoData.sections.achievements.intro'),
				title: t('viewer.demoData.sections.achievements.title'),
				textHtml: t('viewer.demoData.sections.achievements.textHtml'),
			},
			{
				id: 'demo-section-partner-in-crime',
				type: 'partner_in_crime',
				intro: t('viewer.demoData.sections.partnerInCrime.intro'),
				title: t('viewer.demoData.sections.partnerInCrime.title'),
				textHtml: t('viewer.demoData.sections.partnerInCrime.textHtml'),
			},
			{
				id: 'demo-section-promotion',
				type: 'promotion',
				intro: t('viewer.demoData.sections.promotion.intro'),
				title: t('viewer.demoData.sections.promotion.title'),
				textHtml: t('viewer.demoData.sections.promotion.textHtml'),
			},
			{
				id: 'demo-section-superpowers',
				type: 'superpowers',
				intro: t('viewer.demoData.sections.superpowers.intro'),
				title: t('viewer.demoData.sections.superpowers.title'),
				textHtml: t('viewer.demoData.sections.superpowers.textHtml'),
			},
			{
				id: 'demo-section-hidden-talent',
				type: 'hidden_talent',
				intro: t('viewer.demoData.sections.hiddenTalent.intro'),
				title: t('viewer.demoData.sections.hiddenTalent.title'),
				textHtml: t('viewer.demoData.sections.hiddenTalent.textHtml'),
			},
		],
		data: {},
		createdAt: '2026-01-03T10:15:15.000Z',
		updatedAt: '2026-01-03T10:15:15.000Z',
		url: '/spotlight/employee/demo?demo=true',
		imageUrl: null,
		imageHeight: null,
		imageWidth: null,
		thumbnailUrl: null,
		thumbnailHeight: null,
		thumbnailWidth: null,
	});
};
